import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

function FAQItem({ question, answer }) {
  const [open, setOpen] = useState(false);

  const renderAnswer = (ans) => {
    if (typeof ans === 'string' && ans.startsWith('list:')) {
      const parts = ans.split('|');
      const intro = parts[0].replace('list:', '');
      const items = parts.slice(1);
      return (
        <div>
          <p className="mb-3">{intro}</p>
          <ul className="list-disc list-inside ml-2 space-y-1">
            {items.map((item, i) => <li key={i}>{item}</li>)}
          </ul>
        </div>
      );
    }
    return ans;
  };

  return (
    <div className="border-b border-[#E8E8E4]">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between py-5 text-left"
        data-testid={`faq-${question.slice(0, 20).replace(/\s/g, '-').toLowerCase()}`}
      >
        <span className="font-medium text-[#1A1A1A] text-lg pr-4">{question}</span>
        <ChevronDown className={`w-5 h-5 text-[#C4A77D] flex-shrink-0 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          className="pb-5 text-[#595959] leading-relaxed"
        >
          {renderAnswer(answer)}
        </motion.div>
      )}
    </div>
  );
}

export default function CustomerServicePage() {
  const { t } = useLanguage();
  const faqs = t('customerService.faqs') || [];

  return (
    <div className="min-h-screen bg-[#F4EDE6]" data-testid="customer-service-page">
      {/* Hero */}
      <section className="relative py-16 md:py-20 overflow-hidden">
        <video 
          autoPlay muted loop playsInline
          className="absolute inset-0 w-full h-full object-cover"
          src="/kundservice-video.mp4"
        />
        <div className="absolute inset-0 bg-black/40" />
        <div className="container-main text-center text-white relative z-10">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="font-['Avenir_Next'] text-4xl md:text-5xl mb-4"
          >
            {t('customerService.heroTitle')}
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="text-white/80 text-lg max-w-2xl mx-auto"
          >
            {t('customerService.heroSubtitle')}
          </motion.p>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-16 md:py-20">
        <div className="container-main max-w-3xl mx-auto">
          <div className="bg-white rounded-2xl p-8 md:p-12" data-testid="customer-service-faq-list">
            {faqs.map((faq, i) => (
              <FAQItem key={i} question={faq.q} answer={faq.a} />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
